import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { namesList } from "sources/books/drivers";
import components from "./components";

const config = {
    id: {
        // async-select
        label: "Водитель",
        inputProps: { name: "driver" },
        url: namesList,
        filterPropName: "fullName",
        propName: "fullName",
        validators: [requiredField],
        required: true,
        components: components.driver,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
